define('../src/sublayouts/m14-search/m14-search',['jquery', 'slick'], function ($) {

	'use strict';

	var M14_SEARCH = function ($component) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	M14_SEARCH.prototype.init = function () {
		var $this = this;
		this.$html = $('html');
		this.$isRTL = (this.$html.attr('dir') == 'rtl');
		this.shareOpen = false;



		$('.m14-search__item, .m14-search__link').on('click', function (e) {
			e.stopPropagation();
		});

		$('.m14-search__button').off('click.m31searchbtn').on('click.m31searchbtn', function (e) {
			$('.m14-search__button-com').trigger('click.m31search');
		})
		


		$('.m14-search__button-com').off('click.m31search').on('click.m31search', function (e) {

			e.stopPropagation();
			e.preventDefault();
			$this.$panel = $(this).closest('.m14-search').find('.m14-search__panel');
			var	p  = $(this).offset().top,
				ph = $this.$panel.outerHeight(),
				wh = $(window).height(),
				_this = this,
				st = $(window).scrollTop();

			if ((((p-st) + ph) >= wh) && (p-st) >= ph) {
				$this.$panel.addClass('m14-search__panel--top');
			} else {
				$this.$panel.removeClass('m14-search__panel--top');
			}
			if ($this.$panel.attr('aria-expanded') == 'true') {
				$this.hideSharePanel($this.$panel);
			} else {
				$this.showSharePanel($this.$panel);
				console.log($this.$panel)
			}
			$('.m14-search__panel--close, .gray-bg').on('click', function () {
				$this.hideSharePanel($this.$panel);
				$('body').removeClass('unscrollable');
			});
			$('body').addClass('unscrollable');
		});

		//event listener for 'all'
		
	};

	M14_SEARCH.prototype.hideSharePanel = function (panel) {
		try{
			panel.removeClass('m14-search__panel--visible');
			panel.attr('aria-expanded', false);
		} catch(e) {}
	};

	M14_SEARCH.prototype.showSharePanel = function (panel) {
		panel.addClass('m14-search__panel--visible');
		panel.attr('aria-expanded', true);
		panel.fadeIn();
		setTimeout(function() {
			$('.m14-search__input').focus();
		}, 250);
	};

	return M14_SEARCH;
});
